import { Box, Stack, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const ConfirmedOrderRoot = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('spacing-24-16'),
  width: '100%',
  padding: uni('padding-content'),
  borderRadius: uni('border-radius-md'),
  border: `1px solid ${uni('border-static-content-default')}`,
  backgroundColor: uni('bg-static-content-default'),

  [tabletBreakpoint]: {
    borderRadius: uni('border-radius-sm'),
  },
}));

export const ConfirmedOrderHeaderRoot = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-200'),
  width: '100%',
}));

export const ConfirmedOrderHeaderTitleRow = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: uni('spacing-24-16'),
  width: '100%',
}));

export const ConfirmedOrderTitleRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: uni('scale-200'),
  width: '100%',
  color: uni('fg-success-default-rest'),
}));

export const ConfirmedOrderTitle = styled('p')`
  ${uniTypography('text-lg', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
  flex: 1 0 0;
`;

export const ConfirmedOrderDescription = styled('p')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
  margin: 0;
`;

export const ConfirmedOrderDownloadRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',

  [tabletBreakpoint]: {
    '& button': { width: '100%' },
  },
}));
